import { Link } from "react-router-dom";

const SiteFooter = () => {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto max-w-6xl px-6 py-12 grid gap-10 md:grid-cols-5">
        <div className="md:col-span-2">
          <p className="font-semibold text-lg tracking-tight">Wavlynq</p>
          <p className="mt-2 text-sm text-muted-foreground max-w-sm">
            Nine culturally-grounded sibling apps under one umbrella.
            18+ only. Operated by Young's Digital Atelier LLC.
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold mb-3">Apps</p>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-muted-foreground">
            <li><Link to="/fryqnc" className="hover:text-foreground transition-colors">Fryqnc</Link></li>
            <li><Link to="/pulsynq" className="hover:text-foreground transition-colors">Pulsynq</Link></li>
            <li><Link to="/mindlynq" className="hover:text-foreground transition-colors">MindLynq</Link></li>
            <li><Link to="/ablelynq" className="hover:text-foreground transition-colors">Ablelynq</Link></li>
            <li><Link to="/deafwav" className="hover:text-foreground transition-colors">Deafwav</Link></li>
            <li><Link to="/fullynq" className="hover:text-foreground transition-colors">Fullynq</Link></li>
            <li><Link to="/jadesynq" className="hover:text-foreground transition-colors">Jadesynq</Link></li>
            <li><Link to="/openlynq" className="hover:text-foreground transition-colors">Openlynq</Link></li>
            <li><Link to="/spiritsynq" className="hover:text-foreground transition-colors">Spiritsynq</Link></li>
            <li><Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link></li>
            <li><Link to="/a-la-carte" className="hover:text-foreground transition-colors">À la carte</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-sm font-semibold mb-3">Legal & Safety</p>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/support" className="hover:text-foreground transition-colors font-medium text-primary">Support & FAQ</Link></li>
            <li><Link to="/safety" className="hover:text-foreground transition-colors">Safety Center</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-foreground transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/cookies" className="hover:text-foreground transition-colors">Cookie Policy</Link></li>
            <li><Link to="/ai-policy" className="hover:text-foreground transition-colors">AI Use Policy</Link></li>
            <li><Link to="/dmca" className="hover:text-foreground transition-colors">DMCA</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-sm font-semibold mb-3 text-primary">Partners</p>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/partner-access"
                className="inline-flex items-center font-bold text-primary hover:underline underline-offset-4"
              >
                Partner access →
              </Link>
            </li>
            <li>
              <Link
                to="/store"
                className="inline-flex items-center text-muted-foreground hover:text-foreground transition-colors"
              >
                Wavlynq Store
              </Link>
            </li>
            <li className="text-xs text-muted-foreground leading-relaxed pt-1">
              Creator codes, vendor applications &amp; partnership rewards.
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto max-w-6xl px-6 py-6 text-xs text-muted-foreground flex flex-col md:flex-row gap-2 md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Young's Digital Atelier LLC.</p>
          <p>702 Richland Hills Dr #760866, San Antonio, TX 78245</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
